var render = function render(_c,_vm){return (_vm.props.value === null || _vm.props.value === undefined)?_c('span',[_vm._v("-")]):_c('span',[_vm._v(" "+_vm._s(Number(_vm.props.value).toFixed(1))+"% ")])
}
var staticRenderFns = []

export { render, staticRenderFns }